import React from 'react'
import styled from 'styled-components'

const Container = styled.div``

const Color = styled.div<{ color: string }>`
    background-color: ${props => props.color};
    border-radius: 2px;
    height: 34px;
    width: 34px;
    display: inline-block;
    margin-right: 7px;
    position: relative;
`

const SelectedIcon = styled.div`
    position: absolute;
    height: 22px;
    width: 22px;
    border-radius: 50%;
    background: rgb(18, 18, 18);
    opacity: 80%;
    color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 10px;
    line-height: 26px;
`

type Props = {
    colors: string[]
    selectedColor?: string
    onChange: (color) => void
}

const ColorPicker = ({ colors, selectedColor, onChange }: Props) => {
    return (
        <Container>
            {colors.map(c => (
                <Color color={c} key={c} onClick={() => onChange(c)}>
                    {selectedColor === c && <SelectedIcon className="ss-check" />}
                </Color>
            ))}
        </Container>
    )
}

export default ColorPicker
